export default __webpack_public_path__ + "images/1T.bf460cc.png";